module.exports = __webpack_public_path__ + "img/mini_program_code.d806ba96.jpg";